import PartnerBanks from "@/components/landing/PartnerBanks";
import { useCallback } from "react";
import { LOAN_TYPES } from "@/constants/loanTypes";

import SEO from "@/components/common/SEO";

import LoanLayout from "@/components/loans/LoanLayout";
import LoanHero from "@/components/loans/LoanHero";
import LoanOverview from "@/components/loans/LoanOverview";
import LoanBenefits from "@/components/loans/LoanBenefits";
import LoanTypes from "@/components/loans/LoanTypes";
import LoanEligibility from "@/components/loans/LoanEligibility";
import LoanDocuments from "@/components/loans/LoanDocuments";
import LoanProcess from "@/components/loans/LoanProcess";
import WhyMoneyMart from "@/components/loans/WhyMoneyMart";
import LoanFAQ from "@/components/loans/LoanFAQ";
import LoanCTA from "@/components/loans/LoanCTA";
import LeadFormSection from "@/components/loans/LeadFormSection";

import { carLoan } from "@/data/loans";

const CarLoan = () => {
  const scrollToLeadForm = useCallback(() => {
    const el = document.getElementById("lead-form");

    if (el) {
      el.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  }, []);

  return (
    <>
      <SEO {...carLoan.seo} />
      <LoanLayout onCtaClick={scrollToLeadForm}>
        <LoanHero
          {...carLoan.hero}
          onPrimaryClick={scrollToLeadForm}
          onSecondaryClick={scrollToLeadForm}
        />

        <LoanOverview {...carLoan.overview} />

        <LoanBenefits {...carLoan.benefits} />

        <LoanTypes {...carLoan.types} />

        <LoanEligibility
          {...carLoan.eligibility}
          onCheckEligibility={scrollToLeadForm}
        />

        <LoanDocuments {...carLoan.documents} />

        <LoanProcess {...carLoan.process} />

        <WhyMoneyMart {...carLoan.whyMoneyMart} />

        <PartnerBanks />

        <LoanFAQ {...carLoan.faq} />

        <LoanCTA {...carLoan.cta} onApply={scrollToLeadForm} />

        <LeadFormSection {...carLoan.leadForm} loanType="CAR_LOAN" />
      </LoanLayout>
    </>
  );
};

export default CarLoan;
